module.exports = __webpack_public_path__ + "img/cluster-44-advert-square.65a45fef.svg";